<mat-form-field
  (click)="onFocus($event)"
  appearance="outline"
  class="admia-form-item">
  <mat-label>{{ labelTextKey | translate }}</mat-label>

  <input
    #inputFieldWithSelection
    (input)="onInput($event)"
    [matAutocomplete]="auto"
    [formControl]="inputFormControl"
    type="text"
    matInput
  />

  <mat-autocomplete
    #auto="matAutocomplete"
    (closed)="onFocusOut()"
    autoActiveFirstOption>
    <mat-option
      (onSelectionChange)="onItemSelected($event, option)"
      *ngFor="let option of inputData$ | async"
      [value]="itemsQuery.getItemValue(option, key)">
      {{ itemsQuery.getItemText(option, key) }}
    </mat-option>
  </mat-autocomplete>

  <ion-button class="selection-elipsis-buttom-custom" fill="clear" (click)="onOpenListClick($event)" matSuffix>
    <ion-icon name="ellipsis-vertical"> </ion-icon>
  </ion-button>
</mat-form-field>
